export enum ActiveCitizenship {
  CULTURE = 'CULTURE',
  EMPATHY = 'EMPATHY',
  PARTICIPATION = 'PARTICIPATION',
  RESPECT = 'RESPECT',
}

export enum Communication {
  PRESENTATION_SKILLS = 'PRESENTATION_SKILLS',
  VERBAL_AND_NON_VERBAL = 'VERBAL_AND_NON_VERBAL',
  VISUAL_COMMUNICATION = 'VISUAL_COMMUNICATION',
  WRITTEN_COMMUNICATION = 'WRITTEN_COMMUNICATION',
}

export enum Employability {
  COOPERATION = 'COOPERATION',
  DIGITAL_LITERACY = 'DIGITAL_LITERACY',
  NEGOTIATION = 'NEGOTIATION',
  NETWORKING = 'NETWORKING',
  WORK_EFFICIENCY = 'WORK_EFFICIENCY',
}

export enum Learning {
  CREATIVITY = 'CREATIVITY',
  CRITICAL_THINKING = 'CRITICAL_THINKING',
  DIVERGENT_THINKING = 'DIVERGENT_THINKING',
  LEARNING_TO_LEARN = 'LEARNING_TO_LEARN',
  PROBLEM_SOLVING = 'PROBLEM_SOLVING',
  RESEARCH = 'RESEARCH',
}

export enum PersonalDevelopment {
  FINANCIAL_LITERACY = 'FINANCIAL_LITERACY',
  PERSONAL_BRANDING = 'PERSONAL_BRANDING',
  POSITIVE_MINDSET = 'POSITIVE_MINDSET',
  RESILIENCE = 'RESILIENCE',
  SELF_DEVELOPMENT = 'SELF_DEVELOPMENT',
}

export type AscBadgeSkillsType = {
  activeCitizenship?: ActiveCitizenship;
  communication?: Communication;
  employability?: Employability;
  learning?: Learning;
  personalDevelopment?: PersonalDevelopment;
};
